/**
 * Global Toast Notification Provider
 * Uses notistack for non-intrusive toast notifications with custom styling
 */

import React from 'react';
import { SnackbarProvider } from 'notistack';
import { useTheme } from '../contexts/ThemeContext';
import { AppToast } from '../components/common/AppToast';

// ============================================
// Notification Provider Component
// ============================================

interface NotificationProviderProps {
  children: React.ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const { mode } = useTheme();

  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      autoHideDuration={4000}
      preventDuplicate
      style={{
        marginTop: mode === 'dark' ? '16px' : '16px',
      }}
      Components={{
        success: AppToast,
        error: AppToast,
        info: AppToast,
        warning: AppToast,
      }}
    >
      {children}
    </SnackbarProvider>
  );
};
